@import 'styles/mixins';
@import 'styles/variables';

.label {
  @include sm-regular;
  color: var(--neutral-40);
  display: block;
  margin-bottom: 4px;
  margin-top: 12px;
}

.button {
  border: 1px solid var(--neutral-10);
  width: 200px;

  @include for-phone-only {
    width: initial;
  }
}

.option {
  min-width: 150px;
  text-align: left;

  @include for-phone-only {
    min-width: initial;
  }
}
